import {
  setStatusBar, platformLocalGetData, platformLocalSetData,
} from '@/api/native/utils';
import RouterHelper from '@/shared/utils/routerHelper';
import platform from '@/shared/utils/platform';
import router from '@/router';
import { getCurrentSkTabbarInfo, skNativeContainer } from '@/api/native/container';
import URLUtils from '../URLUtils';
import { getTabIdByPath } from '../getTabIdByPath/getTabIdByPath';

/** 当前页面即将刷新标识（location.reload的方式） */
let isPageWillReloadSymbol = false;

export const getIsPageWillReloadSymbol = (): boolean => isPageWillReloadSymbol;

export const setIsPageWillReloadSymbol = (isWillReload: boolean): void => {
  isPageWillReloadSymbol = isWillReload;
};

export const startMonitorPageVisibility = async ():Promise<void> => {
  // 监听webview可见事件，回退时回到某个页面
  // 回退时，根据回退时的页面状态，再处理安卓机型是否将statusBar隐藏或者展示；
  if ((platform.isAndroid || platform.isHarmony) && platform.isHelloApp) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { isShowH5Nav } = router.app.$route.meta;

    // 在容器化中需要判断当前tab是否与路径匹配才执行操作
    if (await skNativeContainer()) {
      const { tabId } = await getCurrentSkTabbarInfo();
      if (tabId === getTabIdByPath()) {
        if (isShowH5Nav) {
          setStatusBar({ isShowStatusBar: false });
        }
      }
    } else {
      if (isShowH5Nav) {
        setStatusBar({ isShowStatusBar: false });
      }
    }
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const backUrl = await platformLocalGetData({
      key: 'AppFinanceH5Web_backUrl',
    });

    // 如果是App中，backUrl返回的为数组
    let backUrlParse = backUrl;
    if (Object.prototype.toString.call(backUrl) === '[object Array]') {
      backUrlParse = (backUrl as string[]).join();
    }

    if (backUrlParse) {
      // 回退完清空backUrl
      platformLocalSetData({
        key: 'AppFinanceH5Web_backUrl',
        value: '',
      });

      if (String(backUrlParse).includes('isPageReload=true')) {
        /** 删除isPageReload参数 */
        const backPath = URLUtils.changeURLArg(String(backUrlParse), 'isPageReload', '');
        const url = `${window.location.origin}${window.location.pathname}#${backPath}`;

        /** 设置即将刷新页面标识，因为此时更新了hash，vue-router会渲染组件，但不会更新完整的页面 */
        setIsPageWillReloadSymbol(true);

        window.location.href = url;
        window.location.reload();
      } else {
        RouterHelper.navigate(String(backUrlParse));
      }
    }
  } catch (e) {
    // 加try catch防止阻断流程;
  }
};
